query GetBillingDefaults {
    billingDefaults {
        email
        firstName
        lastName
        companyName
        address {
            address1
            address2
            city
            state
            postal
            country
        }
    }
}
